import { render, staticRenderFns } from "./ProductsCarousel.vue?vue&type=template&id=5bf29182&scoped=true"
import script from "./ProductsCarousel.vue?vue&type=script&lang=js"
export * from "./ProductsCarousel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf29182",
  null
  
)

export default component.exports